import { UseQueryResult } from "@tanstack/react-query";

export const extractQueryState = <T extends UseQueryResult>(query: T): T => {
  const isLoading =
    query.isLoading || (query.isFetching && query.isPlaceholderData);
  return {
    ...query,
    isLoading,
    isError: !isLoading && query.isError,
    isIdle: !isLoading && query.fetchStatus === "idle",
    isSuccess: !isLoading && query.isSuccess,
  };
};
